export default __webpack_public_path__ + "static/media/Cycling.76642635.svg";